import { createSlice, current } from "@reduxjs/toolkit";
import { MediaTypeEum } from "../../core/enumerations/MediaTypeEnum";

export interface IMediaContent {
  mediaType: string;
  publicUrl: string;
  text?: string;
  isPlaying?: boolean;
  isMute?: boolean;
  totalDuration?: any;
  isRecorded?: boolean;
  backgroundColor?: string;
  file?: any;
  fileName?: any;
  blobUrl?: string;
}
export interface IUploadPostState {
  isLoading: boolean;
  error: string;
  success: string;
  selectedMedia: IMediaContent[];
  isProfilePostDeleted: boolean;
  isPostDetailsUpdated: boolean;
  profilePosts: any;
  postDetails: {
    title: string;
    description: string;
    category: any;
    backgroundColor: string;
    oldBackgroundColor: string;
    cardBackgroundColor: string;
    oldCardBackgroundColor: string;
    mediaContent: IMediaContent[];
    height: string;
    width: string;
  };
  isPostCreated: boolean;
  uploadedMedia: any;
  viewPostLists: any;
  isPostFetched: boolean;
  previousPostDetails: any;
  interactedPost: any;
  isPostCreating: boolean;
}

const initialState: IUploadPostState = {
  isLoading: false,
  error: "",
  success: "",
  selectedMedia: [],
  isProfilePostDeleted: false,
  isPostDetailsUpdated: false,
  profilePosts: {},
  postDetails: {
    title: "",
    description: "",
    category: "",
    backgroundColor: "rgba(0,0,0)",
    oldBackgroundColor: "rgba(13, 13, 13, 1)",
    cardBackgroundColor: "rgba(255, 255, 255)",
    oldCardBackgroundColor: "rgba(13, 13, 13, 1)",
    mediaContent: [],
    height: '',
    width: ''
  },
  isPostCreated: false,
  uploadedMedia: [],
  viewPostLists: {},
  isPostFetched: false,
  previousPostDetails: {
    totalPages: 0,
    currentPage: 0,
    postsData: [],
  },
  interactedPost: {},
  isPostCreating: false,
};

export const createPostRedux: any = createSlice({
  name: "createPostRedux",
  initialState,
  reducers: {
    setCreatePostState: (state: any, action: any) => {
      const newState = {
        ...state,
      };
      newState[action.payload.key] = action.payload.value;
      return newState;
    },

    createPostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPostCreated: false,
        isPostCreating: true,
      };
      return newState;
    },
    createPostSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostCreated: true,
        isPostCreating: false,
      };
      return newState;
    },
    createPostFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostCreated: false,
        isPostCreating: false,
      };
      return newState;
    },

    // delete Profile Post
    deletePostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    deletePostSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfilePostDeleted: true,
      };
      return newState;
    },
    deletePostFailure: (state: any, action: any) => {
      const response = action?.payload;
      const newState = {
        ...state,
        isLoading: false,
        errorMessage: response,
      };
      return newState;
    },

    getPostDetailsByPostIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    getPostDetailsByPostIdSuccess: (state: any, action: any) => {
      const response: any = { ...action?.payload?.data };
      response.postMedias = action?.payload?.data?.postMedias?.map(
        (media: any) => {
          if (
            media?.mediaType === MediaTypeEum.audio ||
            media?.mediaType === MediaTypeEum.voice ||
            media?.mediaType === MediaTypeEum.video
          ) {
            return {
              ...media,
              isPlaying: false,
              isMute: false,
            };
          } else {
            return media;
          }
        }
      );

      const newState = {
        ...state,
        isLoading: false,
        viewPostLists: response,
      };
      return newState;
    },

    getPostDetailsByPostIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    getAllPostsByUserIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPostFetched: true,
      };
      return newState;
    },

    getAllPostsByUserIdSuccess: (state: any, action: any) => {
      const previousData = current(state?.profilePosts);

      const previousPosts = previousData?.postsData
        ? previousData?.postsData
        : [];

      let response = {
        ...action?.payload?.data,
        responseData: action?.payload?.data?.responseData?.map(
          (postData: any, index: number) => {
            return {
              ...postData,
              currentPage: action?.payload?.data?.currentPage,
              postMedias: postData?.postMedias?.map((post: any) => {
                if (
                  post?.mediaType === MediaTypeEum.video ||
                  post?.mediaType === MediaTypeEum.voice ||
                  post?.mediaType === MediaTypeEum.audio
                ) {
                  return {
                    ...post,
                    isPlaying: false,
                    isMute: false,
                  };
                } else {
                  return post;
                }
              }),
            };
          }
        ),
      };

      const formatedData = response?.currentPage === 1 ? [] : previousPosts;

      const newState: any = {
        ...state,
        isLoading: false,
        isPostFetched: false,
        profilePosts: {
          ...response,
          postsData: [...formatedData, ...response?.responseData],
        },
      };

      return newState;
    },

    getAllPostsByUserIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostFetched: false,
      };
      return newState;
    },

    // update Profile Post
    updatePostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    updatePostSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostDetailsUpdated: true,
      };
      return newState;
    },

    updatePostFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        errorMessage: action?.payload,
      };
      return newState;
    },
  },
});

export const {
  setCreatePostState,

  createPostRequest,
  createPostSuccess,
  createPostFailure,

  // post related apis
  deletePostRequest,
  deletePostSuccess,
  deletePostFailure,

  updatePostRequest,
  updatePostSuccess,
  updatePostFailure,

  getPostDetailsByPostIdRequest,
  getPostDetailsByPostIdSuccess,
  getPostDetailsByPostIdFailure,

  getAllPostsByUserIdRequest,
  getAllPostsByUserIdSuccess,
  getAllPostsByUserIdFailure,
} = createPostRedux.actions;

export default createPostRedux.reducer;
